export default __webpack_public_path__ + "bbb42214df97679ba06ab9a6abb8e07e.png";